import { render, staticRenderFns } from "./test2.vue?vue&type=template&id=ecb60984&"
import script from "./test2.vue?vue&type=script&lang=js&"
export * from "./test2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecb60984')) {
      api.createRecord('ecb60984', component.options)
    } else {
      api.reload('ecb60984', component.options)
    }
    module.hot.accept("./test2.vue?vue&type=template&id=ecb60984&", function () {
      api.rerender('ecb60984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/dynamicSegment/test2.vue"
export default component.exports